const storageKey = (campaignId: string) =>
  `creatorsTab.lastViewedCreator.${campaignId}`;

export function readLastViewedCreatorId(campaignId: string): string | null {
  try {
    return sessionStorage.getItem(storageKey(campaignId));
  } catch {
    return null;
  }
}

export function writeLastViewedCreatorId(
  campaignId: string,
  creatorRowId: string
): void {
  try {
    sessionStorage.setItem(storageKey(campaignId), creatorRowId);
  } catch {
    // sessionStorage may be unavailable; last-viewed is best-effort.
  }
}
